import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from '~/components/ProductPageLayout/ProductPageLayout.module.css'
import { useQuote } from '~/context/pricingQuoteContext'
import { useServiceOptions } from '~/context/serviceOptionsContext'

/**
 * Opt-in delivery / assembly checkboxes, rendered in the configurator controls
 * area. The amounts come straight from the live quote breakdown; toggling them
 * updates the shared service-options state the price bar reads. Hidden when the
 * quote has no such services (non-quote products).
 */
export const ServiceOptions: FC = () => {
  const quote = useQuote()
  const { delivery, assembly, setDelivery, setAssembly } = useServiceOptions()

  if (!quote) return null
  const amountOf = (groupSku: string): number =>
    quote.breakdown.find((b) => b.groupSku === groupSku)?.amount ?? 0
  const deliveryAmount = amountOf('delivery')
  const assemblyAmount = amountOf('assembly')
  if (deliveryAmount <= 0 && assemblyAmount <= 0) return null

  return (
    <div className={styles.serviceSection}>
      <p className={styles.serviceSectionTitle}>
        <FormattedMessage id="pricing.services.title" defaultMessage="Servicii" />
      </p>
      <div className={styles.serviceOptions}>
        {deliveryAmount > 0 && (
          <label
            className={`${styles.serviceOption} ${
              delivery ? styles.serviceOptionActive : ''
            }`}
          >
            <input
              type="checkbox"
              className={styles.serviceCheckbox}
              checked={delivery}
              onChange={(e) => setDelivery(e.target.checked)}
            />
            <span className={styles.serviceLabel}>
              <FormattedMessage
                id="pricing.breakdown.delivery"
                defaultMessage="Livrare"
              />
            </span>
            <span className={styles.servicePrice}>
              +{Math.round(deliveryAmount)}&nbsp;
              <FormattedMessage id="homepage.configurator.price.currencyLei" />
            </span>
          </label>
        )}
        {assemblyAmount > 0 && (
          <label
            className={`${styles.serviceOption} ${
              assembly ? styles.serviceOptionActive : ''
            }`}
          >
            <input
              type="checkbox"
              className={styles.serviceCheckbox}
              checked={assembly}
              onChange={(e) => setAssembly(e.target.checked)}
            />
            <span className={styles.serviceLabel}>
              <FormattedMessage
                id="pricing.breakdown.assembly"
                defaultMessage="Asamblare"
              />
            </span>
            <span className={styles.servicePrice}>
              +{Math.round(assemblyAmount)}&nbsp;
              <FormattedMessage id="homepage.configurator.price.currencyLei" />
            </span>
          </label>
        )}
      </div>
    </div>
  )
}
